"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var TabContent = /** @class */ (function (_super) {
    tslib_1.__extends(TabContent, _super);
    function TabContent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setValidationForContextField = function (isValid, contextFieldId) {
            _this.props.onContextFieldValidationChange(contextFieldId, isValid, _this.props.id);
        };
        _this.unregisterContextField = function (contextFieldId) {
            _this.props.onUnregisterContextField(contextFieldId, _this.props.id);
        };
        return _this;
    }
    TabContent.prototype.getChildContext = function () {
        return {
            setValidationForContextField: this.setValidationForContextField,
            unregisterContextField: this.unregisterContextField
        };
    };
    TabContent.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, isSelected = _a.isSelected;
        return (React.createElement("div", { className: className, "data-tab-content": true, "data-tab-content-active": isSelected }, children));
    };
    TabContent.defaultProps = {};
    TabContent.childContextTypes = {
        setValidationForContextField: PropTypes.func,
        unregisterContextField: PropTypes.func
    };
    return TabContent;
}(React.Component));
exports.default = TabContent;
